var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{staticClass:"text-value-lg mt-2 mb-3"},[_c('strong',[_vm._v(_vm._s(_vm.item.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }